<template lang="pug">
.money-buttons(v-if="visible")
  router-link.send-money-btn(:to="target('send')")
    img.send-money-btn__icon(src="@/assets/icons/send.svg" alt="")
    span Send
  router-link.send-money-btn(:to="target('request')")
    img.send-money-btn__icon(src="@/assets/icons/dollar.svg" alt="")
    span Request
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useActingEntity } from '@/composables/useActingEntity';
import { isEmbeddedContext, isEmbeddedRoute } from '@/utils/embeddedUtils';

// "Send" and "Request" on a user or organization profile: open Send money (or its request mode)
// with this recipient filled in. Hidden when signed out, in embeds, and on the profile of whoever
// the user is acting as.
export default defineComponent({
  name: 'SendMoneyButton',
  props: {
    entityType: { type: String as PropType<'User' | 'Organization'>, required: true },
    entityId: { type: String, default: '' },
    name: { type: String, default: '' },
    avatar: { type: String, default: '' },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const { entityType: actingType, entityId: actingId } = useActingEntity();

    const visible = computed(() => (
      !!props.entityId
      && store.getters['users/isMeSignedIn']
      && !isEmbeddedRoute(route.path)
      && !isEmbeddedContext()
      && !(props.entityType === actingType.value && props.entityId === actingId.value)
    ));

    const target = (mode: 'send' | 'request') => ({
      path: '/web/wallet/send',
      query: {
        ...(mode === 'request' ? { mode } : {}),
        to: props.entityId,
        type: props.entityType,
        ...(props.name ? { name: props.name } : {}),
        ...(props.avatar ? { avatar: props.avatar } : {}),
      },
    });

    return { visible, target };
  },
});
</script>

<style lang="scss" scoped>
.money-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.send-money-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  color: #0d9488;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.15s;

  &:hover {
    background: #fff;
  }

  &__icon {
    width: 14px;
    height: 14px;
  }
}
</style>
